<template>
    <MenuItem v-bind="$attrs">
        <div
            class="flex gap-4 items-center px-4 py-2 text-sm"
            :class="[textClasses, disabled ? 'cursor-not-allowed' : 'cursor-pointer']">
            <slot name="icon">
                <Icon
                    v-if="localIcon"
                    :name="localIcon"
                    class="w-5 h-5"
                    :class="iconClass" />
            </slot>
            <slot />
        </div>
    </MenuItem>
</template>

<script setup>
const props = defineProps({
    icon: {
        type: String,
        default: null
    },
    iconClass: {
        type: String,
        default: null
    },
    deleteItem: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    }
})

const localIcon = computed(() => {
    if (props.deleteItem) {
        return 'heroicons:trash'
    } else {
        return props.icon
    }
})

const textClasses = computed(() => {
    if (props.deleteItem) {
        return (!props.disabled ? 'text-danger-600 dark:text-danger-400 hover:bg-danger-100 dark:hover:bg-danger-600' : 'text-danger-200 dark:text-danger-600')
    } else {
        return (!props.disabled ? 'text-gray-700 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-600' : 'text-gray-300 dark:text-gray-500')
    }
})
</script>